<template>
	<div class="turntable-index">
		<img class="canvasimg" ref="canvasimg" src="../../assets/images/turntable.png" alt>
		<img
			class="canvasimg"
			:class="'canvasimg'+index"
			:src="item.cover_img"
			alt
			v-for="(item,index) in turnplate.restaraunts"
			:key="index"
		>
        <!-- 大背景 -->
		<img class="bg" src="../../assets/images/transitionBg.png">
        <div class="content">
            <!--大标题-->
            <img class="title" src="../../assets/images/turntableText.png">
            <!-- 公告 -->
            <div v-link="'/Turntable/WinningList?id='+activity.id">
                <swiper>
                    <swiper-slide class="flex align-center" v-for="(item,index) in order" :key="index">
                        <div class="notice-box">
                            <span class="ellipsis">{{item.time}}&emsp;{{item.text}}</span>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
            <!-- 活动规格 -->
            <div class="flex__around rule-box" @click="rule">
                <span class="fs_24 c_ff">活动规则</span>
            </div>

            <div class="turntable-box">
                <img class="pointer" src="../../assets/images/arrow.png" @click="start">
                <canvas class="item" :width="600/proportion" :height="600/proportion" ref="wheelcanvas" :style="{transform:rotateAngle,transition:rotateTransition == ''?'transform 4s ease-in-out':rotateTransition }">
                </canvas>
            </div>
            <div class="result-box__index">
                <div>
                    <span class="fs_32 c_ff">您还有</span>
                    <span class="fs50 clabel">&nbsp;<span class="fs_50 c_tip fw_600">{{lottery_draw}}</span>&nbsp;</span>
                    <span class="fs_32 c_ff">次抽奖机会</span>
                </div>
                <div class="result-box__btn" v-link="'/Turntable/winningRecord'">
                    <button>中奖纪录</button>
                </div>
            </div>
            <!-- 简介 -->
            <div class="rule-content">
                <div v-html="activity.rule">{{activity.rule}}</div>
            </div>
        </div>
		<div class="result" v-show="model_switch">
			<div class="layer" @click="closeLayer"></div>
			<div class="result-box" v-if="prize_switch">
				<img src="../../assets/images/transitionBg.png">
				<div class="flex__center__between result__info">
					<div class="flex__column align-center">
						<span class="fs_50 c_ff">恭喜您</span>
						<span class="fs_40 c_ff">获得{{current_prize.title}}</span>
					</div>
					<img class="result__prize mt20" :src="current_prize.cover_img" />
					<div class="result__collar mt20" v-link="'/turntable/WinningRecord'">
						<button>马上去领取</button>
					</div>
				</div>
			</div>
			<div class="result-box" v-if="!prize_switch">
				<img src="../../assets/images/transitionBg1.png">
				<div class="flex__center__between result__info">
					<div class="flex__column align-center">
						<span class="fs_50">再接再厉</span>
						<span class="fs_40">很遗憾未中奖</span>
					</div>
					<img class="result__prize mt20" src="../../assets/images/Bitmap.png">
					<div class="result__collar result__collar--lowser mt20" @click="closeLayer">
						<button>关闭</button>
					</div>
				</div>
			</div>
        </div>
    </div>
</template>
<script>
export default {
	name: "TurntableIndex",
	data() {
		return {
			swiperOption: {
				initialSlide: 1,
				loop: true,
				autoplay: 3000,
				direction: "vertical",
				autoplayDisableOnInteraction: false,
				pagination: ".swiper-pagination"
			},
			convert_img: "",
			imgurl: "../../assets/images/turntable.png",
			turnplate: {
				restaraunts: [], // 大转盘奖品名称
				turntables: [], // 大转盘图片
				colors: [], // 大转盘奖品区块对应背景颜色
				// fontcolors:[],				//大转盘奖品区块对应文字颜色
				outsideRadius: 240, // 大转盘外圆的半径
				textRadius: 200, // 大转盘奖品位置距离圆心的距离
				textRadiu: 150,
				insideRadius: 0, // 大转盘内圆的半径
				startAngle: 0, // 开始角度
			},
			width: "",
			height: "",
			proportion: 750 / document.body.clientWidth,
			img_src: "",
			model_switch: false,
			order:{},
            activity: {}, //活动信息
			lottery_draw: 0, //抽奖次数
			animation_check: true, //是否可抽奖
			rotateAngle: 0, //将要旋转的角度
			rotateTransition:'',//控制过渡效果
			startRotatingDegree: 135, //记录旋转度数
			current_prize:{}, //中奖信息
			prize_switch: false,
		};
	},
	created() {
		this.httpPost({
			url: "/Turntable/getIndexData",
			params: {},
			loading: 1
		}).then(res => {
			if (res.code == 1) {
				this.activity=res.data.activity;
				this.turnplate.restaraunts = res.data.prize;
                this.order = res.data.show_order;
				this.lottery_draw=res.data.lottery_draw;
				setTimeout(() => {
					this.craeteImage();
				}, 1000);
			}
		});
	},
	methods: {
		// 绘制 canvas
		craeteImage() {
			let arc = 180 / (this.turnplate.restaraunts.length / 2);
			let canvas = this.$refs.wheelcanvas;
			let ctx = canvas.getContext("2d");
			let canvasimg = this.$refs.canvasimg;
			ctx.drawImage(
				canvasimg,
				0,
				0,
				600 / this.proportion,
				600 / this.proportion
			);
			//font 属性设置或返回画布上文本内容的当前字体属性
			ctx.font = "bold 14px Microsoft YaHei";
			for (let i = 0; i < this.turnplate.restaraunts.length; i++) {
				let angle = this.turnplate.startAngle + i * arc + 22.5;
				//锁画布(为了保存之前的画布状态)

				ctx.save();
				//----绘制奖品开始----
				ctx.fillStyle = "#A84D3D";
				let text = this.turnplate.restaraunts[i].title;
				let img = this.turnplate.turntables[i];

				// 绘制图片
				ctx.save();
				ctx.translate(
					(300 +
						Math.cos((angle + arc / 2) * (Math.PI / 180)) *
							this.turnplate.textRadiu) /
						this.proportion,
					(300 +
						Math.sin((angle + arc / 2) * (Math.PI / 180)) *
							this.turnplate.textRadiu) /
						this.proportion
				);
				ctx.rotate((angle + arc / 2) * (Math.PI / 180) + Math.PI / 2);
				let img_name = "canvasimg" + i;
				let canvasimgs = document.getElementsByClassName(img_name)[0];
				ctx.drawImage(
					canvasimgs,
					-40 / this.proportion,
					-40 / this.proportion,
					80 / this.proportion,
					80 / this.proportion
				);
				ctx.restore();

				// 绘制文字
				ctx.save();
				ctx.translate(
					(300 +
						Math.cos((angle + arc / 2) * (Math.PI / 180)) *
							this.turnplate.textRadius) /
						this.proportion,
					(300 +
						Math.sin((angle + arc / 2) * (Math.PI / 180)) *
							this.turnplate.textRadius) /
						this.proportion
				);
				ctx.rotate((angle + arc / 2) * (Math.PI / 180) + Math.PI / 2);
				ctx.fillText(text, -ctx.measureText(text).width / 2, 0);
				ctx.restore();
			}
			// console.log(canvas.toDataURL("image/png"));
			// ctx.draw();

		},
		rule() {
			this.$dialog.alert({
				message: this.activity.rule
			}).then(() => {
				// on close
			});
		},
		// 开始旋转
		start() {
			this.rotateTransition = '';
			if (this.animation_check && this.lottery_draw > 0) {
				this.animation_check=false;
				this.httpPost({
					url:'/Turntable/submitLuckDraw',
					params:{}
				}).then(res=>{
					if(res.code==1){
						
						let angles=this.startRotatingDegree + res.data.position * (360 / 8)+1800;
						this.rotateAngle= "rotate(" + angles + "deg)";
						// 旋转结束后允许再次触发
						setTimeout(()=>{
							this.animation_check = true;
							this.model_switch=true;
							if(res.data.type==1){
								this.prize_switch=false;
							}else{
								this.prize_switch=true;
								this.current_prize=res.data;
							}
							this.lottery_draw=this.lottery_draw-1;
						}, 4000)
					}
				})
			} else {
				this.$toast("当前状态不可抽奖");
			}
		},
		// 关闭
		closeLayer(){
			this.rotateAngle= "rotate(" + 0 + "deg)";
			this.rotateTransition = 'transform 1s ease-in-out' //控制转动过渡效果的
			this.model_switch=false;
		}
	}
};
</script>
<style scoped>
.canvasimg {
	display: none;
}
canvas.item {
	position: absolute;
}
.blank {
	position: fixed;
	width: 100%;
	height: 100%;
	background: #fff;
	text-align: center;
}
.bg {
	position: fixed;
	top: 0;
    bottom: 0;
	width: 100%;
	height: 100%;
}
.content{
    position: absolute;
    z-index: 1;
    padding-bottom: 30px;
}
.title {
	width: 610px;
	height: 120px;
    margin: 70px 70px 0;
}
.turntable-box {
    position: relative;
	width: 600px;
	height: 600px;
    margin: 30px auto 0;
}
.pointer {
	position: absolute;
	z-index: 1;
	width: 160px;
	height: 180px;
	left: 50%;
	margin-left: -80px;
	top: 50%;
	margin-top: -90px;
}
.swiper-container {
	width: 600px;
	height: 50px;
    margin:  30px auto 0;
	background: #fead78;
	border-radius: 25px;
}
.notice-box {
	padding: 0 20px;
	font-size: 24px;
	color: #0a0a0a;
}
.turntable {
	position: absolute;
	width: 600px;
	height: 600px;
	left: 50%;
	margin-left: -300px;
	top: 50%;
	margin-top: -300px;
}
.result-box__index {
	width: 750px;
    margin: 30px auto 0;
    text-align: center;
}
.result-box__btn {
	width: 300px;
	height: 80px;
    margin: 30px auto 0;
}
.result-box__btn button {
	width: 300px;
	height: 80px;
	line-height: 80px;
	background: rgba(255, 255, 255, 0.2);
	border-radius: 40px;
	font-size: 28px;
	color: #fff;
}
.rule-box {
	position: absolute;
	top: 300px;
	right: 0;
	width: 140px;
	height: 50px;
	border-radius: 25px 0 0 25px;
	background: rgba(255, 255, 255, 0.2);
	line-height: 50px;
}
.rule-content{
    width:650px;
    margin: 30px auto 0;
    padding: 30px;
    background:rgba(0,0,0,.1);
    border-radius:10px;
    color: #fff;
}

/* 结果 */
.layer {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 2;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.7);
}
.result-box {
	position: absolute;
	z-index: 3;
	left: 50%;
	top: 50%;
	margin-left: -260px;
	margin-top: -325px;
	width: 520px;
	height: 650px;
	padding: 50px;
	border-radius: 20px;
	box-sizing: border-box;
}
.result-box > img {
	position: absolute;
	left: 0;
	top: 0;
	width: 520px;
	height: 650px;
	border-radius: 20px;
}
.result__info {
	position: absolute;
	width: 420px;
	height: 550px;
}
.result__prize {
	width: 200px;
	height: 200px;
}
.result__collar button {
	width: 280px;
	height: 80px;
	border-radius: 40px;
	background: #ffce00;
	line-height: 80px;
	font-size: 30px;
	color: #1a1a1a;
}
.result__collar--lowser button {
	background: #4d4d4d;
	color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/pages/turntable/Index.vue